import Image from 'next/image';
import React from 'react';
import cx from 'classnames';

import { useCarousel } from '@/src/components/ui/carousel';

export const ReviewButtons = () => {
  const { scrollPrev, scrollNext, canScrollPrev, canScrollNext } =
    useCarousel();
  return (
    <div className={'mt-5 flex gap-6 pl-4 lg:justify-end'}>
      <button
        onClick={scrollPrev}
        className={cx(!canScrollPrev ? 'opacity-50' : undefined)}
        disabled={!canScrollPrev}
      >
        <Image
          src={'/static/images/arrow.webp'}
          alt={'Arrow'}
          width={40}
          height={40}
          className={'size-[40px] rotate-180'}
        />
      </button>
      <button
        onClick={scrollNext}
        className={cx(!canScrollNext ? 'opacity-50' : undefined)}
        disabled={!canScrollNext}
      >
        <Image
          src={'/static/images/arrow.webp'}
          alt={'Arrow'}
          width={40}
          height={40}
          className={'size-[40px]'}
        />
      </button>
    </div>
  );
};
